import { Stack } from '@mui/material';
import { Outlet } from 'react-router-dom';

import { PageHeader } from '@/components/navigation/PageHeader';

import { ClientCashflowsPageAddButton } from './ClientCashflowsPageAddButton';
import { ClientCashflowsPageImportButton } from './ClientCashflowsPageImportButton';

export function ClientCashflowsPage() {
  return (
    <Stack>
      <PageHeader
        heading="Cash flows"
        action={
          <Stack direction="row" spacing={1}>
            <ClientCashflowsPageImportButton />
            <ClientCashflowsPageAddButton />
          </Stack>
        }
      />
      <Stack p={2} flex={1}>
        <Outlet />
      </Stack>
    </Stack>
  );
}
